import "./svg/nav-cart.svg"

export default {
    name: "nav-cart",
    viewBox: "25 25",
}
